<template>
	<VerticalLayout v-if="cnetSelectOptions.length > 0">
		<span v-if="showLabel">{{ $t(labelKey) }}</span>
		<Select
			class="width-100"
			v-model:value="cnetSelectedId"
			:options="cnetSelectOptions"
			:disabled="disabled"
			@change="onChange"
		/>
	</VerticalLayout>
</template>

<script>
import { Select } from 'ant-design-vue';

import VerticalLayout from '@/components/common/VerticalLayout';

import { useCNetOptions } from '@/components/common/useCNetOptions';


export default {
	components: { VerticalLayout, Select },
	props: {
		onChange: {
			type: Function,
			required: false,
			default: () => {},
		},
		labelKey: {
			type: String,
			default: 'gnss-visibility.cnetLabel',
		},
		showLabel: {
			type: Boolean,
			default: true,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
	},
	setup(props, { expose }) {
		const { cnetSelectOptions, cnetSelectedId } = useCNetOptions();
		expose({
			selectedId: cnetSelectedId,
			options: cnetSelectOptions,
		});
		return {
			cnetSelectedId,
			cnetSelectOptions,
		};
	},
}
</script>
